import {
  LoggerBrowserHandler,
  LoggerBrowserSetupDebugFactory,
  selectColor,
  supportsColors
} from "./chunk-NZQXKE2T.js";
import {
  isBrowser
} from "./chunk-SLALP6PY.js";
import {
  Logger,
  __name,
  formatMilliseconds,
  getTimestamp,
  useLevelFilter,
  useNamespaceFilter
} from "./chunk-FLKB7XIS.js";

// src/browser/base64.ts
var { error } = Logger("zeed:base64");
function urlBase64ToUint8Array(base64String) {
  try {
    let padding = "=".repeat((4 - base64String.length % 4) % 4);
    let base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    let rawData = window.atob(base64);
    let outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  } catch (err) {
    error(err, base64String);
  }
}
__name(urlBase64ToUint8Array, "urlBase64ToUint8Array");

// src/browser/gravatar.ts
var log = Logger("zeed:gravatar");
function gravatar(email, options) {
  function md5cycle(e, t) {
    var n = e[0], r = e[1], i = e[2], s = e[3];
    n = ff(n, r, i, s, t[0], 7, -680876936);
    s = ff(s, n, r, i, t[1], 12, -389564586);
    i = ff(i, s, n, r, t[2], 17, 606105819);
    r = ff(r, i, s, n, t[3], 22, -1044525330);
    n = ff(n, r, i, s, t[4], 7, -176418897);
    s = ff(s, n, r, i, t[5], 12, 1200080426);
    i = ff(i, s, n, r, t[6], 17, -1473231341);
    r = ff(r, i, s, n, t[7], 22, -45705983);
    n = ff(n, r, i, s, t[8], 7, 1770035416);
    s = ff(s, n, r, i, t[9], 12, -1958414417);
    i = ff(i, s, n, r, t[10], 17, -42063);
    r = ff(r, i, s, n, t[11], 22, -1990404162);
    n = ff(n, r, i, s, t[12], 7, 1804603682);
    s = ff(s, n, r, i, t[13], 12, -40341101);
    i = ff(i, s, n, r, t[14], 17, -1502002290);
    r = ff(r, i, s, n, t[15], 22, 1236535329);
    n = gg(n, r, i, s, t[1], 5, -165796510);
    s = gg(s, n, r, i, t[6], 9, -1069501632);
    i = gg(i, s, n, r, t[11], 14, 643717713);
    r = gg(r, i, s, n, t[0], 20, -373897302);
    n = gg(n, r, i, s, t[5], 5, -701558691);
    s = gg(s, n, r, i, t[10], 9, 38016083);
    i = gg(i, s, n, r, t[15], 14, -660478335);
    r = gg(r, i, s, n, t[4], 20, -405537848);
    n = gg(n, r, i, s, t[9], 5, 568446438);
    s = gg(s, n, r, i, t[14], 9, -1019803690);
    i = gg(i, s, n, r, t[3], 14, -187363961);
    r = gg(r, i, s, n, t[8], 20, 1163531501);
    n = gg(n, r, i, s, t[13], 5, -1444681467);
    s = gg(s, n, r, i, t[2], 9, -51403784);
    i = gg(i, s, n, r, t[7], 14, 1735328473);
    r = gg(r, i, s, n, t[12], 20, -1926607734);
    n = hh(n, r, i, s, t[5], 4, -378558);
    s = hh(s, n, r, i, t[8], 11, -2022574463);
    i = hh(i, s, n, r, t[11], 16, 1839030562);
    r = hh(r, i, s, n, t[14], 23, -35309556);
    n = hh(n, r, i, s, t[1], 4, -1530992060);
    s = hh(s, n, r, i, t[4], 11, 1272893353);
    i = hh(i, s, n, r, t[7], 16, -155497632);
    r = hh(r, i, s, n, t[10], 23, -1094730640);
    n = hh(n, r, i, s, t[13], 4, 681279174);
    s = hh(s, n, r, i, t[0], 11, -358537222);
    i = hh(i, s, n, r, t[3], 16, -722521979);
    r = hh(r, i, s, n, t[6], 23, 76029189);
    n = hh(n, r, i, s, t[9], 4, -640364487);
    s = hh(s, n, r, i, t[12], 11, -421815835);
    i = hh(i, s, n, r, t[15], 16, 530742520);
    r = hh(r, i, s, n, t[2], 23, -995338651);
    n = ii(n, r, i, s, t[0], 6, -198630844);
    s = ii(s, n, r, i, t[7], 10, 1126891415);
    i = ii(i, s, n, r, t[14], 15, -1416354905);
    r = ii(r, i, s, n, t[5], 21, -57434055);
    n = ii(n, r, i, s, t[12], 6, 1700485571);
    s = ii(s, n, r, i, t[3], 10, -1894986606);
    i = ii(i, s, n, r, t[10], 15, -1051523);
    r = ii(r, i, s, n, t[1], 21, -2054922799);
    n = ii(n, r, i, s, t[8], 6, 1873313359);
    s = ii(s, n, r, i, t[15], 10, -30611744);
    i = ii(i, s, n, r, t[6], 15, -1560198380);
    r = ii(r, i, s, n, t[13], 21, 1309151649);
    n = ii(n, r, i, s, t[4], 6, -145523070);
    s = ii(s, n, r, i, t[11], 10, -1120210379);
    i = ii(i, s, n, r, t[2], 15, 718787259);
    r = ii(r, i, s, n, t[9], 21, -343485551);
    e[0] = add32(n, e[0]);
    e[1] = add32(r, e[1]);
    e[2] = add32(i, e[2]);
    e[3] = add32(s, e[3]);
  }
  __name(md5cycle, "md5cycle");
  function cmn(e, t, n, r, i, s) {
    t = add32(add32(t, e), add32(r, s));
    return add32(t << i | t >>> 32 - i, n);
  }
  __name(cmn, "cmn");
  function ff(e, t, n, r, i, s, o) {
    return cmn(t & n | ~t & r, e, t, i, s, o);
  }
  __name(ff, "ff");
  function gg(e, t, n, r, i, s, o) {
    return cmn(t & r | n & ~r, e, t, i, s, o);
  }
  __name(gg, "gg");
  function hh(e, t, n, r, i, s, o) {
    return cmn(t ^ n ^ r, e, t, i, s, o);
  }
  __name(hh, "hh");
  function ii(e, t, n, r, i, s, o) {
    return cmn(n ^ (t | ~r), e, t, i, s, o);
  }
  __name(ii, "ii");
  function md51(e) {
    var t = e.length, n = [1732584193, -271733879, -1732584194, 271733878], r;
    for (r = 64; r <= e.length; r += 64) {
      md5cycle(n, md5blk(e.substring(r - 64, r)));
    }
    e = e.substring(r - 64);
    var i = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (r = 0; r < e.length; r++)
      i[r >> 2] |= e.charCodeAt(r) << (r % 4 << 3);
    i[r >> 2] |= 128 << (r % 4 << 3);
    if (r > 55) {
      md5cycle(n, i);
      for (r = 0; r < 16; r++)
        i[r] = 0;
    }
    i[14] = t * 8;
    md5cycle(n, i);
    return n;
  }
  __name(md51, "md51");
  function md5blk(e) {
    var t = [], n;
    for (n = 0; n < 64; n += 4) {
      t[n >> 2] = e.charCodeAt(n) + (e.charCodeAt(n + 1) << 8) + (e.charCodeAt(n + 2) << 16) + (e.charCodeAt(n + 3) << 24);
    }
    return t;
  }
  __name(md5blk, "md5blk");
  function rhex(e) {
    var t = "", n = 0;
    for (; n < 4; n++)
      t += hex_chr[e >> n * 8 + 4 & 15] + hex_chr[e >> n * 8 & 15];
    return t;
  }
  __name(rhex, "rhex");
  function hex(e) {
    for (var t = 0; t < e.length; t++)
      e[t] = rhex(e[t]);
    return e.join("");
  }
  __name(hex, "hex");
  function md5(e) {
    return hex(md51(e));
  }
  __name(md5, "md5");
  function add32(e, t) {
    return e + t & 4294967295;
  }
  __name(add32, "add32");
  var hex_chr = "0123456789abcdef".split("");
  var options = options || {}, base, params = [];
  options = {
    size: options.size || "50",
    rating: options.rating || "g",
    secure: options.secure || location.protocol === "https:",
    backup: options.backup || ""
  };
  email = email.trim().toLowerCase();
  base = options.secure ? "https://secure.gravatar.com/avatar/" : "http://www.gravatar.com/avatar/";
  if (options.rating) {
    params.push("r=" + options.rating);
  }
  if (options.backup) {
    params.push("d=" + encodeURIComponent(options.backup));
  }
  if (options.size) {
    params.push("s=" + options.size);
  }
  return base + md5(email) + "?" + params.join("&");
}
__name(gravatar, "gravatar");
function gravatarURLByEmail(email, defaultURL = "") {
  try {
    return gravatar(email, {
      size: 256,
      backup: "monsterid",
      secure: true
    });
  } catch (error2) {
    log("Gravatar issue: Did not find an image for " + email);
    return defaultURL;
  }
}
__name(gravatarURLByEmail, "gravatarURLByEmail");

// src/browser/localstorage.ts
var log2 = Logger("zeed:localstorage");
var LocalStorage = class {
  constructor(opt) {
    this.pretty = false;
    var _a, _b;
    log2.assert(opt.name, "name required");
    this.name = opt.name;
    this.prefix = `${opt.name}$`;
    this.objectToString = (_a = opt.objectToString) != null ? _a : (data) => {
      return this.pretty ? JSON.stringify(data, null, 2) : JSON.stringify(data);
    };
    this.objectFromString = (_b = opt.objectFromString) != null ? _b : (data) => {
      try {
        return JSON.parse(data);
      } catch (err) {
        log2.warn(`LocalStorage parse error '${err}' in`, data);
      }
    };
  }
  setItem(key, value) {
    const data = this.objectToString(value);
    localStorage.setItem(`${this.prefix}${key}`, data);
  }
  getItem(key) {
    let value = localStorage.getItem(`${this.prefix}${key}`);
    if (value != null) {
      return this.objectFromString(value);
    }
  }
  removeItem(key) {
    localStorage.removeItem(`${this.prefix}${key}`);
  }
  clear() {
    Object.keys(localStorage).filter((key) => key.startsWith(this.prefix)).forEach((key) => {
      localStorage.removeItem(key);
    });
  }
  allKeys() {
    const prefixLength = this.prefix.length;
    return Object.keys(localStorage).filter((key) => key.startsWith(this.prefix)).map((key) => key.substr(prefixLength));
  }
};
__name(LocalStorage, "LocalStorage");

// src/browser/log-browser-classic.ts
var namespaces = {};
var time = getTimestamp();
var useColors = supportsColors();
function LoggerBrowserClassicHandler(level, opt = {}) {
  const { filter = void 0 } = opt;
  const matchesNamespace = useNamespaceFilter(filter);
  const matchesLevel = useLevelFilter(level);
  return (msg) => {
    if (!matchesLevel(msg.level))
      return;
    if (!matchesNamespace(msg.name))
      return;
    const timeNow = getTimestamp();
    let name = msg.name || "";
    let ninfo = namespaces[name || ""];
    if (ninfo == null) {
      ninfo = {
        color: selectColor(name)
      };
      namespaces[name] = ninfo;
    }
    const diff = formatMilliseconds(timeNow - time);
    let args;
    if (opt.colors && useColors) {
      args = opt.nameBrackets ? [`%c[${name}]`] : [`%c${name}`];
      args.push(`color:${ninfo.color}`);
      args.push(...msg.messages);
    } else {
      args = [name, ...msg.messages];
    }
    args.push(`+${diff}`);
    switch (msg.level) {
      case 1 /* info */:
        if (opt.levelHelper)
          args[0] = `I|*   ` + args[0];
        console.info(...args);
        break;
      case 2 /* warn */:
        if (opt.levelHelper)
          args[0] = `W|**  ` + args[0];
        console.warn(...args);
        break;
      case 3 /* error */:
        if (opt.levelHelper)
          args[0] = `E|*** ` + args[0];
        console.error(...args);
        break;
      default:
        if (opt.levelHelper)
          args[0] = `D|    ` + args[0];
        console.debug(...args);
        break;
    }
  };
}
__name(LoggerBrowserClassicHandler, "LoggerBrowserClassicHandler");

// src/browser/log-context-browser.ts
if (isBrowser()) {
  Logger.setHandlers([LoggerBrowserHandler()]);
  Logger.setFactory(LoggerBrowserSetupDebugFactory({}));
}

export {
  urlBase64ToUint8Array,
  gravatarURLByEmail,
  LocalStorage,
  LoggerBrowserClassicHandler
};
//# sourceMappingURL=chunk-RXVGRALQ.js.map